export default "__VITE_ASSET__BPC1TFOl__"